export var eventMap = {
    down: "pointerdown",
    move: "pointermove",
    up: "pointerup",
    cancel: "pointercancel pointerleave"
};

function queryEventMap(e) {
    return eventMap[e] || e;
}

export var applyEventMap = function (events) {
    var eventRegEx = /([^ ]+)/g;
    var appliedEvents = events.replace(eventRegEx, queryEventMap);

    return appliedEvents;
};
